import { useEffect, useState } from 'react';

import { useNetworkStatus } from '../../hooks/useNetworkStatus';

// ============================================================
// OfflineBar
// ============================================================
//
// Sticky banner that appears on top of the viewport whenever the
// app loses connectivity. When the connection comes back we
// briefly flash a "복구됨" message so the user knows the previous
// failure is now resolved, then auto-hide.
// ============================================================

const RECOVERED_VISIBLE_MS = 2_000;

export const OfflineBar = () => {
  const { online } = useNetworkStatus();
  const [showRecovered, setShowRecovered] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    if (!online) {
      setWasOffline(true);
      setShowRecovered(false);
      return undefined;
    }
    if (wasOffline) {
      setShowRecovered(true);
      const timer = setTimeout(() => {
        setShowRecovered(false);
        setWasOffline(false);
      }, RECOVERED_VISIBLE_MS);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [online, wasOffline]);

  if (online && !showRecovered) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className={[
        'fixed left-0 right-0 z-50 px-4 py-2 text-center text-sm font-medium text-white transition-colors',
        online ? 'bg-emerald-600' : 'bg-rose-600',
      ].join(' ')}
      style={{ top: 'var(--safe-area-top, 0px)' }}
    >
      {online ? '연결이 복구되었습니다' : '오프라인 상태입니다'}
    </div>
  );
};
